(function () {
  const SELECTOR = '[data-cycology-banner-2]';
  const SLIDE_SELECTOR = '[data-cycology-banner-2-slide]';

  class CycologyBanner2 {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll(SLIDE_SELECTOR));
      this.duration = Number(root.dataset.slideSpeed) || 5000;
      this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.timer = null;

      if (!this.slides.length) return;

      if (this.slides.length === 1) {
        this.setSlide(0, false);
        return;
      }

      this.setSlide(this.currentIndex, false);
      this.start();
      this.bind();
    }

    bind() {
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(this.root)) this.stop();
      });
    }

    setSlide(index, restart) {
      this.stop();
      this.currentIndex = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

        slide.querySelectorAll('video').forEach((video) => {
          if (active) {
            video.currentTime = 0;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });

      if (restart) this.start();
    }

    start() {
      this.timer = window.setTimeout(() => {
        this.setSlide(this.currentIndex + 1, true);
      }, this.duration);
    }

    stop() {
      if (!this.timer) return;
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  function init(scope) {
    Array.from((scope || document).querySelectorAll(SELECTOR)).forEach((root) => {
      if (root.cycologyBanner2) return;
      root.cycologyBanner2 = new CycologyBanner2(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
